export default {"src":"/_next/static/media/hlr-logo-black.0942cf5c.svg","height":46,"width":140,"blurWidth":0,"blurHeight":0};